import React from 'react';
import FundCompareTable from './FundCompareTable';

export default function PdfFundCompare({
  sectionsConfig = [],
  fundCompareData,
  fundKey,
  SelectedOptions,
  setLoader,
}) {
  const sectionTitle =
    sectionsConfig.find((section) => section.key === 'fund_comparison')
      ?.title || 'Fund Comparison';

  return (
    <>
      <div className="fund-wrap-web m-2 mt-2 p-3">
        <p className="web-header">{sectionTitle}</p>
      </div>

      <div className="fund-wrap-content m-2 mt-2 p-3">
        <div className="d-flex justify-content-between align-items-center">
          <div className="recomandation-content">
            <FundCompareTable
              fundCompareData={fundCompareData}
              fundKey={fundKey}
              SelectedOptions={SelectedOptions}
              setLoader={setLoader}
            />
          </div>
        </div>
      </div>
    </>
  );
}
